import React from "react";
import AppRouter from "./routes/routes";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'aos/dist/aos.css';

function App() {
  return <AppRouter />;
}

export default App;
